"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Stylesheet_1 = require("./Stylesheet");
/**
 * Separates the classes and style objects. Any classes that are pre-registered
 * args are auto expanded into objects.
 */
function extractStyleParts() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var classes = [];
    var objects = [];
    var stylesheet = Stylesheet_1.Stylesheet.getInstance();
    function _processArgs(argsList) {
        for (var _i = 0, argsList_1 = argsList; _i < argsList_1.length; _i++) {
            var arg = argsList_1[_i];
            if (arg) {
                if (typeof arg === 'string') {
                    var translatedArgs = stylesheet.argsFromClassName(arg);
                    if (translatedArgs) {
                        objects.push(translatedArgs);
                    }
                    else {
                        classes.push(arg);
                    }
                }
                else if (Array.isArray(arg)) {
                    _processArgs(arg);
                }
                else if (typeof arg === 'object') {
                    objects.push(arg);
                }
            }
        }
    }
    _processArgs(args);
    return {
        classes: classes,
        objects: objects
    };
}
exports.extractStyleParts = extractStyleParts;
//# sourceMappingURL=extractStyleParts.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@uifabric/merge-styles/lib/extractStyleParts.js
// module id = ../node_modules/@uifabric/merge-styles/lib/extractStyleParts.js
// module chunks = 1